import { createApp } from 'vue';
import Toast from './toast.vue';
import Loading from './loading.vue';
import Open from './open.vue';

// toast
const mountNode = document.createElement('div');
document.body.appendChild(mountNode);

const app = createApp(Toast);
const toastInstance = app.mount(mountNode);

// 自动挂载到 window
if (!window.$toast) {
  window.$toast = options => {
    if (typeof options === 'string') {
      toastInstance.showToast({ text: options, type: 'default', duration: 1500 });
    } else {
      toastInstance.showToast(options);
    }
  };
}

// loading
const loadingMountNode = document.createElement('div');
document.body.appendChild(loadingMountNode);
const loadingApp = createApp(Loading);
const loadingComponent = loadingApp.mount(loadingMountNode);

if (!window.$loading) {
  window.$loading = (value, remark) => {
    if (typeof value === 'boolean') {
      loadingComponent.setLoading(value ? '正在加载...' : '', remark);
    } else {
      loadingComponent.setLoading(value, remark);
    }
  };
}

// open
const openMountNode = document.createElement('div');
document.body.appendChild(openMountNode);
const openApp = createApp(Open);
const openComponent = openApp.mount(openMountNode);

if (!window.$open) {
  window.$open = options => {
    openComponent.showOpen(options);
  };
}
